<script setup lang="ts">
import type { CharacteristicsGridProps } from '.';

import { cn } from '~/utils';
import { useId } from 'vue';

import { CharacteristicCard } from '~/components/CharacteristicCard';
import { Skeleton } from '~/components/ui/skeleton';

defineProps<CharacteristicsGridProps>();
</script>

<template>
	<div
		class="grid w-full grid-cols-2 gap-1 md:grid-cols-3 md:gap-2 lg:grid-cols-2 2xl:grid-cols-3"
	>
		<template v-if="isLoading">
			<div
				v-for="index in 6"
				:key="`characteristics-skeleton-${index}-${useId()}`"
				class="flex h-[54px] items-start gap-2 rounded-sm bg-white-dark-1 px-4 py-2"
			>
				<div class="flex flex-col gap-0.5">
					<Skeleton
						:is-active="isLoading"
						class="h-3 w-16 md:h-4 md:w-20"
						variant="white"
					/>
				</div>
			</div>
		</template>

		<template v-else>
			<CharacteristicCard
				v-for="characteristic in characteristics"
				:key="`characteristic:${characteristic.value}`"
				:title="characteristic.title"
				:value="characteristic.value"
				:is-link="characteristic.isLink"
				:link-to="characteristic.linkTo"
				class="w-full"
				:class="characteristic.class"
			>
				<template #icon>
					<Component
						:is="characteristic.icon"
						class="size-5"
						:class="characteristic.iconClass"
					/>
				</template>
			</CharacteristicCard>
		</template>
	</div>
</template>
